export const mpLogo = require("./images/mercado-pago-logo.png");
export const chileTiketLogo = require("./images/logo.png");
export const ticketApproved = require("./images/ticket-approved.png");
export const ticketRejected = require("./images/ticket-rejected.png");
export const emptyEventImage = require("./images/empty-event.jpg");
export const pagoHubLogo = require("./images/pago-hub-logo.png");
export const webpayLogo = require("./images/webpay-logo.png");
export const fintocLogo = require("./images/fintoc-logo.png");
